import FrequencyTrendSignalGetters from "./FrequencyTrendSignalGetters";
import FrequencyTrendSignalsActions from "./FrequencyTrendSignalsActions";
import FrequencyTrendSignalsMutations from "./FrequencyTrendSignalsMutations";
import TrendSignalsService from "@/services/common/TrendSignalsService";

const state = TrendSignalsService.EmptyFrequencyTrendSignalStateFactory();

const { actions } = FrequencyTrendSignalsActions;

const { getters } = FrequencyTrendSignalGetters;

const { mutations } = FrequencyTrendSignalsMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	getters,
	mutations,
};